module.exports = __webpack_public_path__ + "img/1.d5d2dc84.jpg";